export const PathNamekAppsRoutes = {
  ACCOUNTABILITY: "rendicioncuentas",
  MACROGENERATORS: "macrogenerators",
  PRESETEEISM: "presentismo",
};
